<template>
  <div class="box">
    <div class="controls">
      <div v-if="!animationOn" class="p-icon" @click="startAnimation">
        <PlayIcon title="play" :size="48" />
      </div>
      <div v-else class="s-icon" @click="stopAnimation">
        <StopIcon title="stop" :size="48" />
      </div>
    </div>
    <svg
      id="Aquarena_Effekte"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 400 400"
      style="enable-background:new 0 0 400 400;"
      xml:space="preserve"
      width="100%"
      height="100%"
    >
      <g id="Tube">
        <path
          class="st0"
          d="M200,18.5C99.76,18.5,18.5,99.76,18.5,200S99.76,381.5,200,381.5S381.5,300.24,381.5,200S300.24,18.5,200,18.5
		z M238.5,230.77c-6.88-8.56-11-19.43-11-31.27c0-11.84,4.12-22.71,11-31.27c6.88,8.56,11,19.43,11,31.27
		C249.5,211.34,245.38,222.21,238.5,230.77z"
        />
        <path
          class="st1"
          d="M199.5,39.5c-88.37,0-160,71.63-160,160s71.63,160,160,160s160-71.63,160-160S287.87,39.5,199.5,39.5z
		 M238.5,230.77c-6.88-8.56-11-19.43-11-31.27c0-11.84,4.12-22.71,11-31.27c6.88,8.56,11,19.43,11,31.27
		C249.5,211.34,245.38,222.21,238.5,230.77z"
        />
        <path
          class="st2"
          d="M246,77c-50.5-18.5-115.73-16.5-151.5,6.5s-55,69.64-55,116c0,45.52,18.61,90.39,51.13,114.13
		C123.16,337.38,194,342,240,324s102.5-66.5,102.5-124.5S296.5,95.5,246,77z M238.5,230.77c-6.88-8.56-11-19.43-11-31.27
		c0-11.84,4.12-22.71,11-31.27c6.88,8.56,11,19.43,11,31.27C249.5,211.34,245.38,222.21,238.5,230.77z"
        />
        <path
          class="st3"
          d="M238.5,230.77c-6.88-8.56-11-19.43-11-31.27c0-11.83,4.12-22.7,10.99-31.26c-3.55-4.43-7.83-8.25-12.67-11.26
		C218.18,152.24,206,138,187,138c-28,0-52.75,30-52.75,62.25S157,262,187,262c19,0,30.16-14.94,37.52-19.2
		C234.07,237.27,238.75,230.39,238.5,230.77z"
        />
        <path
          class="st4"
          d="M238.5,230.77c-6.88-8.56-11-19.43-11-31.27c0-11.83,4.12-22.7,10.99-31.26c-3.55-4.43-7.83-8.25-12.67-11.26
		C199,156.98,154,171,154,199.5s45,43.3,70.52,43.3c6.57-3.8,12.14-9.83,14-12.01C238.51,230.78,238.51,230.78,238.5,230.77z"
        />
        <path
          class="st5"
          d="M238.5,168.23c-3.55-4.43-7.83-8.25-12.67-11.25C218.18,152.24,206,138,187,138c-28,0-52.75,30-52.75,62.25
		c0,14.07,4.33,27.62,11.71,38.42c-3.17-81.48,78.23-73.09,90.52-67.73C237.12,170.02,237.79,169.11,238.5,168.23z"
        />
        <path
          class="st1"
          d="M200,303c-56.79,0-103-46.21-103-103c0-56.79,46.21-103,103-103c56.79,0,103,46.21,103,103
		C303,256.79,256.79,303,200,303z M200,103c-53.49,0-97,43.51-97,97c0,53.49,43.51,97,97,97c53.49,0,97-43.51,97-97
		C297,146.51,253.49,103,200,103z"
        />
        <path
          class="st1"
          d="M200,268.5c-37.77,0-68.5-30.73-68.5-68.5c0-37.77,30.73-68.5,68.5-68.5c37.77,0,68.5,30.73,68.5,68.5
		C268.5,237.77,237.77,268.5,200,268.5z M200,136.5c-35.01,0-63.5,28.49-63.5,63.5c0,35.01,28.49,63.5,63.5,63.5
		c35.01,0,63.5-28.49,63.5-63.5C263.5,164.99,235.01,136.5,200,136.5z"
        />
        <path
          class="st6"
          d="M218,245.5c-21.78,0-39.5-20.41-39.5-45.5s17.72-45.5,39.5-45.5c1.62,0,3.22,0.13,4.8,0.35
		c-1.3-0.99-2.7-2.13-4.22-3.33c-0.19,0-0.38-0.02-0.58-0.02c-23.43,0-42.5,21.76-42.5,48.5c0,26.43,18.62,47.97,41.68,48.48
		c1.34-1.12,2.58-2.18,3.75-3.11C219.96,245.44,218.99,245.5,218,245.5z"
        />
        <path
          class="st6"
          d="M232.6,162.05c-8.27,8.79-13.6,22.52-13.6,37.95c0,15.11,5.12,28.6,13.1,37.4c0.5-0.43,0.99-0.87,1.47-1.31
		C225.92,227.66,221,214.62,221,200c0-14.92,5.13-28.2,13.05-36.61C233.58,162.93,233.1,162.49,232.6,162.05z"
        />
        <g id="Lichter">
          <path
            class="st7"
            d="M76.5,199.5c0,42,13,78,11,90s-7,13-11.25,12.03C53.3,273.84,39.5,238.28,39.5,199.5
			c0-38.66,13.71-74.12,36.54-101.77C77.5,96.5,84.5,99.5,87.5,111.5S76.5,157.5,76.5,199.5z"
          />
          <path
            class="st4"
            d="M230.23,215.78c-9.02-0.08-29.97,1.29-55.69,13.23c4.71,2.83,9.93,5.23,15.31,7.2
			c19.33-9.6,36.14-11.47,44.34-11.75C232.6,221.72,231.27,218.81,230.23,215.78z"
          />
          <path
            class="st7"
            d="M346.47,262.83c-27.97-23.03-84.78-43.7-100.02-46.11c-1.89,5.13-4.58,9.87-7.94,14.05
			c-0.03-0.04-0.05-0.07-0.08-0.11c-0.03,0.04-0.05,0.07-0.08,0.11c28.38,14.76,65.79,43.17,84.92,70.14
			C332.67,289.44,340.51,276.64,346.47,262.83z"
          />
          <ellipse class="st8" cx="238.5" cy="199.5" rx="11" ry="31.27" />
        </g>
      </g>
      <g id="Twister" :class="{ inactive: index < 2 }">
        <g v-if="onOffArray[0]" id="TwisterLightstrip1" class="st12">
          <path
            :style="{ fill: showingColors[0] }"
            d="M267.25,184.77c-0.52-6.12-1.71-12.19-3.54-18.06c-2.39-7.7-5.85-15.07-10.26-21.84l-2.29,1.56
			c4.31,6.5,7.73,13.6,10.11,21.04c1.82,5.69,3.03,11.57,3.59,17.52c0.55,5.96,0.63,11.96-0.41,17.82
			c-1.97,11.74-7.46,22.85-15.33,31.83c-2.63,3-5.55,5.77-8.69,8.25l1.13,1.45c3.26-2.52,6.28-5.35,9.02-8.41
			c8.17-9.17,13.93-20.57,16.08-32.74c0.52-3.04,0.88-6.12,0.91-9.21C267.63,190.89,267.5,187.83,267.25,184.77z"
          />
          <path
            :style="{ fill: showingColors[0] }"
            d="M121.26,125.06c-3.37,2.14-6.64,4.43-9.78,6.9c-19.44,15.21-33.98,36.52-41.31,60.12
			c-3.69,11.79-5.59,24.15-5.69,36.51c-0.05,12.29,1.08,24.6,3.48,36.67c1.16,5.82,2.62,11.57,4.36,17.25
			c3.64,5.62,7.64,10.98,11.96,16.05c-4.87-11.02-8.6-22.56-11.06-34.37c-2.42-11.68-3.63-23.63-3.68-35.57
			c-0.01-11.88,1.72-23.76,5.17-35.14c6.86-22.76,20.68-43.44,39.33-58.29c3-2.4,6.13-4.63,9.36-6.73L121.26,125.06z"
          />
          <path
            :style="{ fill: showingColors[0] }"
            d="M214.7,116.23c11.01,4.5,20.89,11.64,28.9,20.44c2.32,2.55,4.46,5.28,6.44,8.11l2.31-1.58
			c-2.02-2.95-4.23-5.77-6.61-8.44c-8.22-9.17-18.4-16.68-29.81-21.46c-11.37-4.84-23.9-7.01-36.21-6.42
			c-12.3,0.42-24.54,2.81-36.1,7.08c-6.88,2.53-13.51,5.74-19.8,9.52l2.12,3.38c6.03-3.69,12.39-6.84,19.01-9.33
			c11.15-4.22,22.98-6.64,34.9-7.15C191.75,109.7,203.7,111.68,214.7,116.23z"
          />
          <path
            :style="{ fill: showingColors[0] }"
            d="M239.65,243.49c-6.06,4.62-12.95,8.13-20.33,10.05c-2.89,0.72-5.83,1.29-8.81,1.48
			c-2.97,0.22-5.98,0.19-8.98,0.02c-5.99-0.34-11.97-1.3-17.66-3.19c-5.68-1.88-11.07-4.7-15.6-8.61c-2.46-2.09-4.63-4.51-6.48-7.15
			l-0.92,0.6c1.89,2.74,4.1,5.26,6.63,7.44c4.63,4.06,10.16,7.01,15.95,8.98c5.81,1.98,11.9,3.01,17.99,3.41
			c3.05,0.2,6.11,0.25,9.18,0.05c3.08-0.17,6.12-0.73,9.1-1.45c7.64-1.91,14.77-5.48,21.05-10.19L239.65,243.49z"
          />
        </g>
        <g v-if="onOffArray[1]" id="TwisterLightstrip2" class="st12">
          <path
            :style="{ fill: showingColors[1] }"
            d="M258.32,236.78c3.96-4.7,7.41-9.83,10.27-15.27c3.76-7.13,6.53-14.79,8.19-22.69l-2.72-0.51
			c-1.55,7.65-4.15,15.08-7.73,22.02c-2.73,5.31-6.04,10.32-9.85,14.93c-3.82,4.6-8.01,8.9-12.89,12.31
			c-9.7,6.91-21.43,10.89-33.35,11.67c-3.98,0.26-8,0.16-11.98-0.31l-0.23,1.82c4.09,0.52,8.22,0.66,12.33,0.43
			c12.26-0.71,24.39-4.69,34.52-11.78c2.52-1.78,4.95-3.7,7.16-5.87C254.26,241.38,256.33,239.12,258.32,236.78z"
          />
          <path
            :style="{ fill: showingColors[1] }"
            d="M197.32,91.33c-3.9-0.87-7.83-1.56-11.8-2.04c-24.5-2.99-49.85,1.8-71.72,13.3
			c-10.95,5.73-21.03,13.12-29.84,21.79c-8.73,8.66-16.63,18.16-23.47,28.39c-3.29,4.93-6.33,10.04-9.11,15.28
			c-1.4,6.54-2.36,13.16-2.89,19.81c4.35-11.24,9.87-22.03,16.48-32.12c6.55-9.98,14.14-19.28,22.55-27.76
			c8.39-8.4,18.02-15.58,28.5-21.19c20.94-11.24,45.34-16.09,69.03-13.4c3.82,0.43,7.62,1.06,11.38,1.86L197.32,91.33z"
          />
          <path
            :style="{ fill: showingColors[1] }"
            d="M269.62,151.16c4.6,10.96,6.54,23,5.99,34.89c-0.16,3.45-0.58,6.88-1.18,10.28l2.74,0.52
			c0.65-3.51,1.09-7.07,1.3-10.64c0.68-12.3-1.22-24.8-5.9-36.25c-4.62-11.46-11.94-21.86-21.06-30.15
			c-8.99-8.4-19.34-15.36-30.53-20.52c-6.66-3.08-13.61-5.5-20.73-7.27l-0.89,3.89c6.87,1.65,13.6,3.93,20.04,6.84
			c10.87,4.9,20.94,11.55,29.74,19.62C258.02,130.32,265.07,140.17,269.62,151.16z"
          />
          <path
            :style="{ fill: showingColors[1] }"
            d="M197.28,258.79c-7.55-1.02-14.91-3.4-21.48-7.27c-2.56-1.53-5.04-3.21-7.28-5.18
			c-2.25-1.94-4.36-4.1-6.36-6.34c-4-4.48-7.54-9.38-10.23-14.74c-2.69-5.34-4.5-11.16-4.95-17.12c-0.26-3.22-0.08-6.46,0.47-9.64
			l-1.08-0.23c-0.6,3.27-0.82,6.62-0.58,9.95c0.41,6.15,2.23,12.14,4.93,17.63c2.71,5.51,6.29,10.54,10.32,15.13
			c2.02,2.29,4.14,4.49,6.46,6.53c2.3,2.05,4.84,3.81,7.46,5.41c6.75,4.05,14.32,6.56,22.09,7.68L197.28,258.79z"
          />
        </g>
        <g v-if="onOffArray[2]" id="TwisterLightstrip3" class="st12">
          <path
            :style="{ fill: showingColors[2] }"
            d="M215.23,267.25c6.12-0.52,12.19-1.71,18.06-3.54c7.7-2.39,15.07-5.85,21.84-10.26l-1.56-2.29
			c-6.5,4.31-13.6,7.73-21.04,10.11c-5.69,1.82-11.57,3.03-17.52,3.59c-5.96,0.55-11.96,0.63-17.82-0.41
			c-11.74-1.97-22.85-7.46-31.83-15.33c-3-2.63-5.77-5.55-8.25-8.69l-1.45,1.13c2.52,3.26,5.35,6.28,8.41,9.02
			c9.17,8.17,20.57,13.93,32.74,16.08c3.04,0.52,6.12,0.88,9.21,0.91C209.11,267.63,212.17,267.5,215.23,267.25z"
          />
          <path
            :style="{ fill: showingColors[2] }"
            d="M274.94,121.26c-2.14-3.37-4.43-6.64-6.9-9.78c-15.21-19.44-36.52-33.98-60.12-41.31
			c-11.79-3.69-24.15-5.59-36.51-5.69c-12.29-0.05-24.6,1.08-36.67,3.48c-5.82,1.16-11.57,2.62-17.25,4.36
			c-5.62,3.64-10.98,7.64-16.05,11.96c11.02-4.87,22.56-8.6,34.37-11.06c11.68-2.42,23.63-3.63,35.57-3.68
			c11.88-0.01,23.76,1.72,35.14,5.17c22.76,6.86,43.44,20.68,58.29,39.33c2.4,3,4.63,6.13,6.73,9.36L274.94,121.26z"
          />
          <path
            :style="{ fill: showingColors[2] }"
            d="M283.77,214.7c-4.5,11.01-11.64,20.89-20.44,28.9c-2.55,2.32-5.28,4.46-8.11,6.44l1.58,2.31
			c2.95-2.02,5.77-4.23,8.44-6.61c9.17-8.22,16.68-18.4,21.46-29.81c4.84-11.37,7.01-23.9,6.42-36.21
			c-0.42-12.3-2.81-24.54-7.08-36.1c-2.53-6.88-5.74-13.51-9.52-19.8l-3.38,2.12c3.69,6.03,6.84,12.39,9.33,19.01
			c4.22,11.15,6.64,22.98,7.15,34.9C290.3,191.75,288.32,203.7,283.77,214.7z"
          />
          <path
            :style="{ fill: showingColors[2] }"
            d="M156.51,239.65c-4.62-6.06-8.13-12.95-10.05-20.33c-0.72-2.89-1.29-5.83-1.48-8.81
			c-0.22-2.97-0.19-5.98-0.02-8.98c0.34-5.99,1.3-11.97,3.19-17.66c1.88-5.68,4.7-11.07,8.61-15.6c2.09-2.46,4.51-4.63,7.15-6.48
			l-0.6-0.92c-2.74,1.89-5.26,4.1-7.44,6.63c-4.06,4.63-7.01,10.16-8.98,15.95c-1.98,5.81-3.01,11.9-3.41,17.99
			c-0.2,3.05-0.25,6.11-0.05,9.18c0.17,3.08,0.73,6.12,1.45,9.1c1.91,7.64,5.48,14.77,10.19,21.05L156.51,239.65z"
          />
        </g>
        <g v-if="onOffArray[3]" id="TwisterLightstrip4" class="st12">
          <path
            :style="{ fill: showingColors[3] }"
            d="M163.22,258.32c4.7,3.96,9.83,7.41,15.27,10.27c7.13,3.76,14.79,6.53,22.69,8.19l0.51-2.72
			c-7.65-1.55-15.08-4.15-22.02-7.73c-5.31-2.73-10.32-6.04-14.93-9.85c-4.6-3.82-8.9-8.01-12.31-12.89
			c-6.91-9.7-10.89-21.43-11.67-33.35c-0.26-3.98-0.16-8,0.31-11.98l-1.82-0.23c-0.52,4.09-0.66,8.22-0.43,12.33
			c0.71,12.26,4.69,24.39,11.78,34.52c1.78,2.52,3.7,4.95,5.87,7.16C158.62,254.26,160.88,256.33,163.22,258.32z"
          />
          <path
            :style="{ fill: showingColors[3] }"
            d="M308.67,197.32c0.87-3.9,1.56-7.83,2.04-11.8c2.99-24.5-1.8-49.85-13.3-71.72
			c-5.73-10.95-13.12-21.03-21.79-29.84c-8.66-8.73-18.16-16.63-28.39-23.47c-4.93-3.29-10.04-6.33-15.28-9.11
			c-6.54-1.4-13.16-2.36-19.81-2.89c11.24,4.35,22.03,9.87,32.12,16.48c9.98,6.55,19.28,14.14,27.76,22.55
			c8.4,8.39,15.58,18.02,21.19,28.5c11.24,20.94,16.09,45.34,13.4,69.03c-0.43,3.82-1.06,7.62-1.86,11.38L308.67,197.32z"
          />
          <path
            :style="{ fill: showingColors[3] }"
            d="M248.84,269.62c-10.96,4.6-23,6.54-34.89,5.99c-3.45-0.16-6.88-0.58-10.28-1.18l-0.52,2.74
			c3.51,0.65,7.07,1.09,10.64,1.3c12.3,0.68,24.8-1.22,36.25-5.9c11.46-4.62,21.86-11.94,30.15-21.06
			c8.4-8.99,15.36-19.34,20.52-30.53c3.08-6.66,5.5-13.61,7.27-20.73l-3.89-0.89c-1.65,6.87-3.93,13.6-6.84,20.04
			c-4.9,10.87-11.55,20.94-19.62,29.74C269.68,258.02,259.83,265.07,248.84,269.62z"
          />
          <path
            :style="{ fill: showingColors[3] }"
            d="M141.21,197.28c1.02-7.55,3.4-14.91,7.27-21.48c1.53-2.56,3.21-5.04,5.18-7.28c1.94-2.25,4.1-4.36,6.34-6.36
			c4.48-4,9.38-7.54,14.74-10.23c5.34-2.69,11.16-4.5,17.12-4.95c3.22-0.26,6.46-0.08,9.64,0.47l0.23-1.08
			c-3.27-0.6-6.62-0.82-9.95-0.58c-6.15,0.41-12.14,2.23-17.63,4.93c-5.51,2.71-10.54,6.29-15.13,10.32
			c-2.29,2.02-4.49,4.14-6.53,6.46c-2.05,2.3-3.81,4.84-5.41,7.46c-4.05,6.75-6.56,14.32-7.68,22.09L141.21,197.28z"
          />
        </g>
        <g v-if="onOffArray[4]" id="TwisterLightstrip5" class="st12">
          <path
            :style="{ fill: showingColors[4] }"
            d="M132.75,215.23c0.52,6.12,1.71,12.19,3.54,18.06c2.39,7.7,5.85,15.07,10.26,21.84l2.29-1.56
			c-4.31-6.5-7.73-13.6-10.11-21.04c-1.82-5.69-3.03-11.57-3.59-17.52c-0.55-5.96-0.63-11.96,0.41-17.82
			c1.97-11.74,7.46-22.85,15.33-31.83c2.63-3,5.55-5.77,8.69-8.25l-1.13-1.45c-3.26,2.52-6.28,5.35-9.02,8.41
			c-8.17,9.17-13.93,20.57-16.08,32.74c-0.52,3.04-0.88,6.12-0.91,9.21C132.37,209.11,132.5,212.17,132.75,215.23z"
          />
          <path
            :style="{ fill: showingColors[4] }"
            d="M278.74,274.94c3.37-2.14,6.64-4.43,9.78-6.9c19.44-15.21,33.98-36.52,41.31-60.12
			c3.69-11.79,5.59-24.15,5.69-36.51c0.05-12.29-1.08-24.6-3.48-36.67c-1.16-5.82-2.62-11.57-4.36-17.25
			c-3.64-5.62-7.64-10.98-11.96-16.05c4.87,11.02,8.6,22.56,11.06,34.37c2.42,11.68,3.63,23.63,3.68,35.57
			c0.01,11.88-1.72,23.76-5.17,35.14c-6.86,22.76-20.68,43.44-39.33,58.29c-3,2.4-6.13,4.63-9.36,6.73L278.74,274.94z"
          />
          <path
            :style="{ fill: showingColors[4] }"
            d="M185.3,283.77c-11.01-4.5-20.89-11.64-28.9-20.44c-2.32-2.55-4.46-5.28-6.44-8.11l-2.31,1.58
			c2.02,2.95,4.23,5.77,6.61,8.44c8.22,9.17,18.4,16.68,29.81,21.46c11.37,4.84,23.9,7.01,36.21,6.42
			c12.3-0.42,24.54-2.81,36.1-7.08c6.88-2.53,13.51-5.74,19.8-9.52l-2.12-3.38c-6.03,3.69-12.39,6.84-19.01,9.33
			c-11.15,4.22-22.98,6.64-34.9,7.15C208.25,290.3,196.3,288.32,185.3,283.77z"
          />
          <path
            :style="{ fill: showingColors[4] }"
            d="M160.35,156.51c6.06-4.62,12.95-8.13,20.33-10.05c2.89-0.72,5.83-1.29,8.81-1.48
			c2.97-0.22,5.98-0.19,8.98-0.02c5.99,0.34,11.97,1.3,17.66,3.19c5.68,1.88,11.07,4.7,15.6,8.61c2.46,2.09,4.63,4.51,6.48,7.15
			l0.92-0.6c-1.89-2.74-4.1-5.26-6.63-7.44c-4.63-4.06-10.16-7.01-15.95-8.98c-5.81-1.98-11.9-3.01-17.99-3.41
			c-3.05-0.2-6.11-0.25-9.18-0.05c-3.08,0.17-6.12,0.73-9.1,1.45c-7.64,1.91-14.77,5.48-21.05,10.19L160.35,156.51z"
          />
        </g>
        <g v-if="onOffArray[5]" id="TwisterLightstrip6" class="st12">
          <path
            :style="{ fill: showingColors[5] }"
            d="M141.68,163.22c-3.96,4.7-7.41,9.83-10.27,15.27c-3.76,7.13-6.53,14.79-8.19,22.69l2.72,0.51
			c1.55-7.65,4.15-15.08,7.73-22.02c2.73-5.31,6.04-10.32,9.85-14.93c3.82-4.6,8.01-8.9,12.89-12.31
			c9.7-6.91,21.43-10.89,33.35-11.67c3.98-0.26,8-0.16,11.98,0.31l0.23-1.82c-4.09-0.52-8.22-0.66-12.33-0.43
			c-12.26,0.71-24.39,4.69-34.52,11.78c-2.52,1.78-4.95,3.7-7.16,5.87C145.74,158.62,143.67,160.88,141.68,163.22z"
          />
          <path
            :style="{ fill: showingColors[5] }"
            d="M202.68,308.67c3.9,0.87,7.83,1.56,11.8,2.04c24.5,2.99,49.85-1.8,71.72-13.3
			c10.95-5.73,21.03-13.12,29.84-21.79c8.73-8.66,16.63-18.16,23.47-28.39c3.29-4.93,6.33-10.04,9.11-15.28
			c1.4-6.54,2.36-13.16,2.89-19.81c-4.35,11.24-9.87,22.03-16.48,32.12c-6.55,9.98-14.14,19.28-22.55,27.76
			c-8.39,8.4-18.02,15.58-28.5,21.19c-20.94,11.24-45.34,16.09-69.03,13.4c-3.82-0.43-7.62-1.06-11.38-1.86L202.68,308.67z"
          />
          <path
            :style="{ fill: showingColors[5] }"
            d="M130.38,248.84c-4.6-10.96-6.54-23-5.99-34.89c0.16-3.45,0.58-6.88,1.18-10.28l-2.74-0.52
			c-0.65,3.51-1.09,7.07-1.3,10.64c-0.68,12.3,1.22,24.8,5.9,36.25c4.62,11.46,11.94,21.86,21.06,30.15
			c8.99,8.4,19.34,15.36,30.53,20.52c6.66,3.08,13.61,5.5,20.73,7.27l0.89-3.89c-6.87-1.65-13.6-3.93-20.04-6.84
			c-10.87-4.9-20.94-11.55-29.74-19.62C141.98,269.68,134.93,259.83,130.38,248.84z"
          />
          <path
            :style="{ fill: showingColors[5] }"
            d="M202.72,141.21c7.55,1.02,14.91,3.4,21.48,7.27c2.56,1.53,5.04,3.21,7.28,5.18c2.25,1.94,4.36,4.1,6.36,6.34
			c4,4.48,7.54,9.38,10.23,14.74c2.69,5.34,4.5,11.16,4.95,17.12c0.26,3.22,0.08,6.46-0.47,9.64l1.08,0.23
			c0.6-3.27,0.82-6.62,0.58-9.95c-0.41-6.15-2.23-12.14-4.93-17.63c-2.71-5.51-6.29-10.54-10.32-15.13
			c-2.02-2.29-4.14-4.49-6.46-6.53c-2.3-2.05-4.84-3.81-7.46-5.41c-6.75-4.05-14.32-6.56-22.09-7.68L202.72,141.21z"
          />
        </g>
        <g v-if="onOffArray[6]" id="TwisterLightstrip7" class="st12">
          <path
            :style="{ fill: showingColors[6] }"
            d="M184.77,132.75c-6.12,0.52-12.19,1.71-18.06,3.54c-7.7,2.39-15.07,5.85-21.84,10.26l1.56,2.29
			c6.5-4.31,13.6-7.73,21.04-10.11c5.69-1.82,11.57-3.03,17.52-3.59c5.96-0.55,11.96-0.63,17.82,0.41
			c11.74,1.97,22.85,7.46,31.83,15.33c3,2.63,5.77,5.55,8.25,8.69l1.45-1.13c-2.52-3.26-5.35-6.28-8.41-9.02
			c-9.17-8.17-20.57-13.93-32.74-16.08c-3.04-0.52-6.12-0.88-9.21-0.91C190.89,132.37,187.83,132.5,184.77,132.75z"
          />
          <path
            :style="{ fill: showingColors[6] }"
            d="M125.06,278.74c2.14,3.37,4.43,6.64,6.9,9.78c15.21,19.44,36.52,33.98,60.12,41.31
			c11.79,3.69,24.15,5.59,36.51,5.69c12.29,0.05,24.6-1.08,36.67-3.48c5.82-1.16,11.57-2.62,17.25-4.36
			c5.62-3.64,10.98-7.64,16.05-11.96c-11.02,4.87-22.56,8.6-34.37,11.06c-11.68,2.42-23.63,3.63-35.57,3.68
			c-11.88,0.01-23.76-1.72-35.14-5.17c-22.76-6.86-43.44-20.68-58.29-39.33c-2.4-3-4.63-6.13-6.73-9.36L125.06,278.74z"
          />
          <path
            :style="{ fill: showingColors[6] }"
            d="M116.23,185.3c4.5-11.01,11.64-20.89,20.44-28.9c2.55-2.32,5.28-4.46,8.11-6.44l-1.58-2.31
			c-2.95,2.02-5.77,4.23-8.44,6.61c-9.17,8.22-16.68,18.4-21.46,29.81c-4.84,11.37-7.01,23.9-6.42,36.21
			c0.42,12.3,2.81,24.54,7.08,36.1c2.53,6.88,5.74,13.51,9.52,19.8l3.38-2.12c-3.69-6.03-6.84-12.39-9.33-19.01
			c-4.22-11.15-6.64-22.98-7.15-34.9C109.7,208.25,111.68,196.3,116.23,185.3z"
          />
          <path
            :style="{ fill: showingColors[6] }"
            d="M243.49,160.35c4.62,6.06,8.13,12.95,10.05,20.33c0.72,2.89,1.29,5.83,1.48,8.81
			c0.22,2.97,0.19,5.98,0.02,8.98c-0.34,5.99-1.3,11.97-3.19,17.66c-1.88,5.68-4.7,11.07-8.61,15.6c-2.09,2.46-4.51,4.63-7.15,6.48
			l0.6,0.92c2.74-1.89,5.26-4.1,7.44-6.63c4.06-4.63,7.01-10.16,8.98-15.95c1.98-5.81,3.01-11.9,3.41-17.99
			c0.2-3.05,0.25-6.11,0.05-9.18c-0.17-3.08-0.73-6.12-1.45-9.1c-1.91-7.64-5.48-14.77-10.19-21.05L243.49,160.35z"
          />
        </g>
        <g v-if="onOffArray[7]" id="TwisterLightstrip8" class="st12">
          <path
            :style="{ fill: showingColors[7] }"
            d="M236.78,141.68c-4.7-3.96-9.83-7.41-15.27-10.27c-7.13-3.76-14.79-6.53-22.69-8.19l-0.51,2.72
			c7.65,1.55,15.08,4.15,22.02,7.73c5.31,2.73,10.32,6.04,14.93,9.85c4.6,3.82,8.9,8.01,12.31,12.89
			c6.91,9.7,10.89,21.43,11.67,33.35c0.26,3.98,0.16,8-0.31,11.98l1.82,0.23c0.52-4.09,0.66-8.22,0.43-12.33
			c-0.71-12.26-4.69-24.39-11.78-34.52c-1.78-2.52-3.7-4.95-5.87-7.16C241.38,145.74,239.12,143.67,236.78,141.68z"
          />
          <path
            :style="{ fill: showingColors[7] }"
            d="M91.33,202.68c-0.87,3.9-1.56,7.83-2.04,11.8c-2.99,24.5,1.8,49.85,13.3,71.72
			c5.73,10.95,13.12,21.03,21.79,29.84c8.66,8.73,18.16,16.63,28.39,23.47c4.93,3.29,10.04,6.33,15.28,9.11
			c6.54,1.4,13.16,2.36,19.81,2.89c-11.24-4.35-22.03-9.87-32.12-16.48c-9.98-6.55-19.28-14.14-27.76-22.55
			c-8.4-8.39-15.58-18.02-21.19-28.5c-11.24-20.94-16.09-45.34-13.4-69.03c0.43-3.82,1.06-7.62,1.86-11.38L91.33,202.68z"
          />
          <path
            :style="{ fill: showingColors[7] }"
            d="M151.16,130.38c10.96-4.6,23-6.54,34.89-5.99c3.45,0.16,6.88,0.58,10.28,1.18l0.52-2.74
			c-3.51-0.65-7.07-1.09-10.64-1.3c-12.3-0.68-24.8,1.22-36.25,5.9c-11.46,4.62-21.86,11.94-30.15,21.06
			c-8.4,8.99-15.36,19.34-20.52,30.53c-3.08,6.66-5.5,13.61-7.27,20.73l3.89,0.89c1.65-6.87,3.93-13.6,6.84-20.04
			c4.9-10.87,11.55-20.94,19.62-29.74C130.32,141.98,140.17,134.93,151.16,130.38z"
          />
          <path
            :style="{ fill: showingColors[7] }"
            d="M258.79,202.72c-1.02,7.55-3.4,14.91-7.27,21.48c-1.53,2.56-3.21,5.04-5.18,7.28
			c-1.94,2.25-4.1,4.36-6.34,6.36c-4.48,4-9.38,7.54-14.74,10.23c-5.34,2.69-11.16,4.5-17.12,4.95c-3.22,0.26-6.46,0.08-9.64-0.47
			l-0.23,1.08c3.27,0.6,6.62,0.82,9.95,0.58c6.15-0.41,12.14-2.23,17.63-4.93c5.51-2.71,10.54-6.29,15.13-10.32
			c2.29-2.02,4.49-4.14,6.53-6.46c2.05-2.3,3.81-4.84,5.41-7.46c4.05-6.75,6.56-14.32,7.68-22.09L258.79,202.72z"
          />
        </g>
      </g>
      <g id="Runninglight" :class="{ inactive: index > 1 }">
        <path
          v-if="onOffArray[0]"
          id="Runninglight1"
          :style="{ fill: showingColors[0] }"
          d="M200,50c40.07,0,77.73,15.6,106.07,43.93C334.4,122.27,350,159.93,350,200
		s-15.6,77.73-43.93,106.07S240.07,350,200,350s-77.73-15.6-106.07-43.93C65.6,277.73,50,240.07,50,200s15.6-77.73,43.93-106.07
		C122.27,65.6,159.93,50,200,50 M200,49c-83.39,0-151,67.61-151,151s67.61,151,151,151s151-67.61,151-151S283.39,49,200,49L200,49z"
        />
        <path
          v-if="onOffArray[0]"
          id="Runninglight2"
          :style="{ fill: showingColors[0] }"
          d="M200,54.95c38.74,0,75.17,15.09,102.57,42.48c27.4,27.4,42.48,63.82,42.48,102.57
		s-15.09,75.17-42.48,102.57c-27.4,27.4-63.82,42.48-102.57,42.48s-75.17-15.09-102.57-42.48c-27.4-27.4-42.48-63.82-42.48-102.57
		s15.09-75.17,42.48-102.57C124.83,70.04,161.26,54.95,200,54.95 M200,54c-80.63,0-146,65.37-146,146s65.37,146,146,146
		s146-65.37,146-146S280.63,54,200,54L200,54z"
        />
        <path
          v-if="onOffArray[1]"
          id="Runninglight3"
          :style="{ fill: showingColors[1] }"
          d="M200,59.44c37.55,0,72.84,14.62,99.39,41.17c26.55,26.55,41.17,61.85,41.17,99.39
		s-14.62,72.84-41.17,99.39c-26.55,26.55-61.85,41.17-99.39,41.17s-72.84-14.62-99.39-41.17C74.06,272.84,59.44,237.55,59.44,200
		s14.62-72.84,41.17-99.39C127.16,74.06,162.45,59.44,200,59.44 M200,58.5c-78.15,0-141.5,63.35-141.5,141.5S121.85,341.5,200,341.5
		S341.5,278.15,341.5,200S278.15,58.5,200,58.5L200,58.5z"
        />
        <path
          v-if="onOffArray[1]"
          id="Runninglight4"
          :style="{ fill: showingColors[1] }"
          d="M200,63.89c36.36,0,70.54,14.16,96.24,39.87c25.71,25.71,39.87,59.89,39.87,96.24
		s-14.16,70.54-39.87,96.24c-25.71,25.71-59.89,39.87-96.24,39.87s-70.54-14.16-96.24-39.87C78.05,270.54,63.89,236.36,63.89,200
		s14.16-70.54,39.87-96.24C129.46,78.05,163.64,63.89,200,63.89 M200,63c-75.66,0-137,61.34-137,137s61.34,137,137,137
		s137-61.34,137-137S275.66,63,200,63L200,63z"
        />
        <path
          v-if="onOffArray[2]"
          id="Runninglight5"
          :style="{ fill: showingColors[2] }"
          d="M200,68.38c35.16,0,68.21,13.69,93.07,38.55c24.86,24.86,38.55,57.91,38.55,93.07
		s-13.69,68.21-38.55,93.07s-57.91,38.55-93.07,38.55s-68.21-13.69-93.07-38.55C82.07,268.21,68.38,235.16,68.38,200
		s13.69-68.21,38.55-93.07C131.79,82.07,164.84,68.38,200,68.38 M200,67.5c-73.18,0-132.5,59.32-132.5,132.5S126.82,332.5,200,332.5
		S332.5,273.18,332.5,200S273.18,67.5,200,67.5L200,67.5z"
        />
        <path
          v-if="onOffArray[2]"
          id="Runninglight6"
          :style="{ fill: showingColors[2] }"
          d="M200,72.83c33.97,0,65.9,13.23,89.92,37.25c24.02,24.02,37.25,55.95,37.25,89.92
		s-13.23,65.9-37.25,89.92c-24.02,24.02-55.95,37.25-89.92,37.25s-65.9-13.23-89.92-37.25C86.06,265.9,72.83,233.97,72.83,200
		s13.23-65.9,37.25-89.92C134.1,86.06,166.03,72.83,200,72.83 M200,72c-70.69,0-128,57.31-128,128s57.31,128,128,128
		s128-57.31,128-128S270.69,72,200,72L200,72z"
        />
        <path
          v-if="onOffArray[3]"
          id="Runninglight7"
          :style="{ fill: showingColors[3] }"
          d="M200,77.32c32.77,0,63.58,12.76,86.75,35.93c23.17,23.17,35.93,53.98,35.93,86.75
		s-12.76,63.58-35.93,86.75s-53.98,35.93-86.75,35.93s-63.58-12.76-86.75-35.93C90.08,263.58,77.32,232.77,77.32,200
		s12.76-63.58,35.93-86.75C136.42,90.08,167.23,77.32,200,77.32 M200,76.5c-68.21,0-123.5,55.29-123.5,123.5S131.79,323.5,200,323.5
		S323.5,268.21,323.5,200S268.21,76.5,200,76.5L200,76.5z"
        />
        <path
          v-if="onOffArray[3]"
          id="Runninglight8"
          :style="{ fill: showingColors[3] }"
          d="M200,81.77c31.58,0,61.27,12.3,83.6,34.63c22.33,22.33,34.63,52.02,34.63,83.6
		s-12.3,61.27-34.63,83.6c-22.33,22.33-52.02,34.63-83.6,34.63s-61.27-12.3-83.6-34.63c-22.33-22.33-34.63-52.02-34.63-83.6
		s12.3-61.27,34.63-83.6C138.73,94.07,168.42,81.77,200,81.77 M200,81c-65.72,0-119,53.28-119,119s53.28,119,119,119
		s119-53.28,119-119S265.72,81,200,81L200,81z"
        />
        <path
          v-if="onOffArray[4]"
          id="Runninglight9_1_"
          :style="{ fill: showingColors[4] }"
          d="M200,85.76c30.51,0,59.2,11.88,80.78,33.46c21.58,21.58,33.46,50.26,33.46,80.78
		s-11.88,59.2-33.46,80.78s-50.26,33.46-80.78,33.46s-59.2-11.88-80.78-33.46C97.64,259.2,85.76,230.51,85.76,200
		s11.88-59.2,33.46-80.78C140.8,97.64,169.49,85.76,200,85.76 M200,85c-63.51,0-115,51.49-115,115s51.49,115,115,115
		s115-51.49,115-115S263.51,85,200,85L200,85z"
        />
        <path
          v-if="onOffArray[4]"
          id="Runninglight10"
          :style="{ fill: showingColors[4] }"
          d="M200,89.53c29.51,0,57.25,11.49,78.11,32.36c20.86,20.86,32.36,48.61,32.36,78.11
		s-11.49,57.25-32.36,78.11c-20.86,20.86-48.61,32.36-78.11,32.36s-57.25-11.49-78.11-32.36c-20.86-20.86-32.36-48.61-32.36-78.11
		s11.49-57.25,32.36-78.11C142.75,101.02,170.49,89.53,200,89.53 M200,88.81c-61.41,0-111.19,49.78-111.19,111.19
		S138.59,311.19,200,311.19S311.19,261.41,311.19,200S261.41,88.81,200,88.81L200,88.81z"
        />
        <path
          v-if="onOffArray[5]"
          id="Runninglight11"
          :style="{ fill: showingColors[5] }"
          d="M200,92.95c28.59,0,55.48,11.14,75.7,31.35c20.22,20.22,31.35,47.1,31.35,75.7
		s-11.14,55.48-31.35,75.7c-20.22,20.22-47.1,31.35-75.7,31.35s-55.48-11.14-75.7-31.35c-20.22-20.22-31.35-47.1-31.35-75.7
		s11.14-55.48,31.35-75.7C144.52,104.08,171.41,92.95,200,92.95 M200,92.24c-59.52,0-107.76,48.25-107.76,107.76
		S140.48,307.76,200,307.76S307.76,259.52,307.76,200S259.52,92.24,200,92.24L200,92.24z"
        />
        <path
          v-if="onOffArray[5]"
          id="Runninglight12"
          :style="{ fill: showingColors[5] }"
          d="M200,96.34c27.69,0,53.72,10.78,73.3,30.36c19.58,19.58,30.36,45.61,30.36,73.3
		s-10.78,53.72-30.36,73.3c-19.58,19.58-45.61,30.36-73.3,30.36s-53.72-10.78-73.3-30.36c-19.58-19.58-30.36-45.61-30.36-73.3
		s10.78-53.72,30.36-73.3C146.28,107.12,172.31,96.34,200,96.34 M200,95.66c-57.62,0-104.34,46.71-104.34,104.34
		S142.38,304.34,200,304.34S304.34,257.62,304.34,200S257.62,95.66,200,95.66L200,95.66z"
        />
        <path
          v-if="onOffArray[6]"
          id="Runninglight13"
          :style="{ fill: showingColors[6] }"
          d="M200,99.76c26.78,0,51.95,10.43,70.88,29.36c18.93,18.93,29.36,44.11,29.36,70.88
		s-10.43,51.95-29.36,70.88s-44.11,29.36-70.88,29.36s-51.95-10.43-70.88-29.36c-18.93-18.93-29.36-44.11-29.36-70.88
		s10.43-51.95,29.36-70.88C148.05,110.18,173.22,99.76,200,99.76 M200,99.09c-55.73,0-100.91,45.18-100.91,100.91
		S144.27,300.91,200,300.91S300.91,255.73,300.91,200S255.73,99.09,200,99.09L200,99.09z"
        />
        <path
          v-if="onOffArray[6]"
          id="Runninglight14"
          :style="{ fill: showingColors[6] }"
          d="M200,103.15c25.87,0,50.19,10.07,68.48,28.37c18.29,18.29,28.37,42.61,28.37,68.48
		s-10.07,50.19-28.37,68.48c-18.29,18.29-42.61,28.37-68.48,28.37s-50.19-10.07-68.48-28.37c-18.29-18.29-28.37-42.61-28.37-68.48
		s10.07-50.19,28.37-68.48S174.13,103.15,200,103.15 M200,102.52c-53.84,0-97.48,43.64-97.48,97.48s43.64,97.48,97.48,97.48
		s97.48-43.64,97.48-97.48S253.84,102.52,200,102.52L200,102.52z"
        />
        <path
          v-if="onOffArray[7]"
          id="Runninglight15"
          :style="{ fill: showingColors[7] }"
          d="M200,106.57c24.96,0,48.42,9.72,66.07,27.37c17.65,17.65,27.37,41.11,27.37,66.07
		s-9.72,48.42-27.37,66.07s-41.11,27.37-66.07,27.37s-48.42-9.72-66.07-27.37c-17.65-17.65-27.37-41.11-27.37-66.07
		s9.72-48.42,27.37-66.07C151.58,116.29,175.04,106.57,200,106.57 M200,105.94c-51.95,0-94.06,42.11-94.06,94.06
		s42.11,94.06,94.06,94.06s94.06-42.11,94.06-94.06S251.95,105.94,200,105.94L200,105.94z"
        />
        <path
          v-if="onOffArray[7]"
          id="Runninglight16"
          :style="{ fill: showingColors[7] }"
          d="M200,109.96c24.05,0,46.66,9.37,63.67,26.37c17.01,17.01,26.37,39.62,26.37,63.67
		s-9.37,46.66-26.37,63.67c-17.01,17.01-39.62,26.37-63.67,26.37s-46.66-9.37-63.67-26.37c-17.01-17.01-26.37-39.62-26.37-63.67
		s9.37-46.66,26.37-63.67C153.34,119.33,175.95,109.96,200,109.96 M200,109.37c-50.05,0-90.63,40.58-90.63,90.63
		s40.58,90.63,90.63,90.63s90.63-40.58,90.63-90.63S250.05,109.37,200,109.37L200,109.37z"
        />
        <path
          v-if="onOffArray[0]"
          id="Runninglight17"
          :style="{ fill: showingColors[0] }"
          d="M200,113.08c23.22,0,45.04,9.04,61.46,25.46c16.42,16.42,25.46,38.24,25.46,61.46
		s-9.04,45.04-25.46,61.46s-38.24,25.46-61.46,25.46s-45.04-9.04-61.46-25.46c-16.42-16.42-25.46-38.24-25.46-61.46
		s9.04-45.04,25.46-61.46C154.96,122.12,176.78,113.08,200,113.08 M200,112.5c-48.32,0-87.5,39.18-87.5,87.5s39.18,87.5,87.5,87.5
		s87.5-39.18,87.5-87.5S248.32,112.5,200,112.5L200,112.5z"
        />
        <path
          v-if="onOffArray[0]"
          id="Runninglight18"
          :style="{ fill: showingColors[0] }"
          d="M200,115.95c22.45,0,43.56,8.74,59.43,24.62c15.88,15.88,24.62,36.98,24.62,59.43
		s-8.74,43.56-24.62,59.43c-15.88,15.88-36.98,24.62-59.43,24.62s-43.56-8.74-59.43-24.62c-15.88-15.88-24.62-36.98-24.62-59.43
		s8.74-43.56,24.62-59.43C156.44,124.69,177.55,115.95,200,115.95 M200,115.4c-46.72,0-84.6,37.88-84.6,84.6s37.88,84.6,84.6,84.6
		s84.6-37.88,84.6-84.6S246.72,115.4,200,115.4L200,115.4z"
        />
        <path
          v-if="onOffArray[1]"
          id="Runninglight19"
          :style="{ fill: showingColors[1] }"
          d="M200,118.55c21.76,0,42.21,8.47,57.6,23.86c15.38,15.38,23.86,35.84,23.86,57.6
		s-8.47,42.21-23.86,57.6s-35.84,23.86-57.6,23.86s-42.21-8.47-57.6-23.86c-15.38-15.38-23.86-35.84-23.86-57.6
		s8.47-42.21,23.86-57.6C157.79,127.02,178.24,118.55,200,118.55 M200,118c-45.28,0-82,36.71-82,82s36.71,82,82,82s82-36.71,82-82
		S245.28,118,200,118L200,118z"
        />
        <path
          v-if="onOffArray[1]"
          id="Runninglight20"
          :style="{ fill: showingColors[1] }"
          d="M200,121.13c21.07,0,40.87,8.2,55.77,23.1c14.9,14.9,23.1,34.7,23.1,55.77
		s-8.2,40.87-23.1,55.77c-14.9,14.9-34.7,23.1-55.77,23.1s-40.87-8.2-55.77-23.1c-14.9-14.9-23.1-34.7-23.1-55.77
		s8.2-40.87,23.1-55.77C159.13,129.33,178.93,121.13,200,121.13 M200,120.61c-43.84,0-79.39,35.54-79.39,79.39
		s35.54,79.39,79.39,79.39s79.39-35.54,79.39-79.39S243.84,120.61,200,120.61L200,120.61z"
        />
        <path
          v-if="onOffArray[2]"
          id="Runninglight21"
          :style="{ fill: showingColors[2] }"
          d="M200,123.73c20.37,0,39.53,7.93,53.93,22.34c14.41,14.41,22.34,33.56,22.34,53.93
		s-7.93,39.53-22.34,53.93c-14.41,14.41-33.56,22.34-53.93,22.34s-39.53-7.93-53.93-22.34c-14.41-14.41-22.34-33.56-22.34-53.93
		s7.93-39.53,22.34-53.93C160.47,131.66,179.63,123.73,200,123.73 M200,123.22c-42.4,0-76.78,34.38-76.78,76.78
		s34.38,76.78,76.78,76.78s76.78-34.38,76.78-76.78S242.4,123.22,200,123.22L200,123.22z"
        />
        <path
          v-if="onOffArray[2]"
          id="Runninglight22"
          :style="{ fill: showingColors[2] }"
          d="M200,126.31c19.68,0,38.19,7.67,52.11,21.58c13.92,13.92,21.58,32.42,21.58,52.11
		s-7.67,38.19-21.58,52.11c-13.92,13.92-32.42,21.58-52.11,21.58s-38.19-7.67-52.11-21.58c-13.92-13.92-21.58-32.42-21.58-52.11
		s7.67-38.19,21.58-52.11S180.32,126.31,200,126.31 M200,125.83c-40.96,0-74.17,33.21-74.17,74.17s33.21,74.17,74.17,74.17
		s74.17-33.21,74.17-74.17S240.96,125.83,200,125.83L200,125.83z"
        />
        <path
          v-if="onOffArray[3]"
          id="Runninglight23"
          :style="{ fill: showingColors[3] }"
          d="M200,128.91c18.99,0,36.84,7.39,50.27,20.82c13.43,13.43,20.82,31.28,20.82,50.27
		s-7.39,36.84-20.82,50.27c-13.43,13.43-31.28,20.82-50.27,20.82s-36.84-7.39-50.27-20.82c-13.43-13.43-20.82-31.28-20.82-50.27
		s7.39-36.84,20.82-50.27C163.16,136.3,181.01,128.91,200,128.91 M200,128.44c-39.52,0-71.56,32.04-71.56,71.56
		s32.04,71.56,71.56,71.56s71.56-32.04,71.56-71.56S239.52,128.44,200,128.44L200,128.44z"
        />
        <path
          v-if="onOffArray[3]"
          id="Runninglight24"
          :style="{ fill: showingColors[3] }"
          d="M200,131.49c18.3,0,35.5,7.13,48.44,20.07c12.94,12.94,20.07,30.14,20.07,48.44
		s-7.13,35.5-20.07,48.44c-12.94,12.94-30.14,20.07-48.44,20.07s-35.5-7.13-48.44-20.07c-12.94-12.94-20.07-30.14-20.07-48.44
		s7.13-35.5,20.07-48.44C164.5,138.62,181.7,131.49,200,131.49 M200,131.04c-38.08,0-68.96,30.87-68.96,68.96
		s30.87,68.96,68.96,68.96s68.96-30.87,68.96-68.96S238.08,131.04,200,131.04L200,131.04z"
        />
        <path
          v-if="onOffArray[4]"
          id="Runninglight25"
          :style="{ fill: showingColors[4] }"
          d="M200,133.94c17.65,0,34.23,6.87,46.71,19.35c12.48,12.48,19.35,29.07,19.35,46.71
		s-6.87,34.23-19.35,46.71c-12.48,12.48-29.07,19.35-46.71,19.35s-34.23-6.87-46.71-19.35c-12.48-12.48-19.35-29.07-19.35-46.71
		s6.87-34.23,19.35-46.71C165.77,140.81,182.35,133.94,200,133.94 M200,133.5c-36.73,0-66.5,29.77-66.5,66.5s29.77,66.5,66.5,66.5
		s66.5-29.77,66.5-66.5S236.73,133.5,200,133.5L200,133.5z"
        />
        <path
          v-if="onOffArray[4]"
          id="Runninglight26"
          :style="{ fill: showingColors[4] }"
          d="M200,136.12c17.06,0,33.1,6.64,45.17,18.71c12.07,12.07,18.71,28.11,18.71,45.17
		s-6.64,33.1-18.71,45.17c-12.07,12.07-28.11,18.71-45.17,18.71s-33.1-6.64-45.17-18.71c-12.07-12.07-18.71-28.11-18.71-45.17
		s6.64-33.1,18.71-45.17C166.9,142.77,182.94,136.12,200,136.12 M200,135.7c-35.51,0-64.3,28.79-64.3,64.3s28.79,64.3,64.3,64.3
		s64.3-28.79,64.3-64.3S235.51,135.7,200,135.7L200,135.7z"
        />
        <path
          v-if="onOffArray[5]"
          id="Runninglight27"
          :style="{ fill: showingColors[5] }"
          d="M200,138.1c16.54,0,32.08,6.44,43.77,18.13c11.69,11.69,18.13,27.24,18.13,43.77
		s-6.44,32.08-18.13,43.77c-11.69,11.69-27.24,18.13-43.77,18.13s-32.08-6.44-43.77-18.13c-11.69-11.69-18.13-27.24-18.13-43.77
		s6.44-32.08,18.13-43.77C167.92,144.54,183.46,138.1,200,138.1 M200,137.68c-34.42,0-62.32,27.9-62.32,62.32
		s27.9,62.32,62.32,62.32s62.32-27.9,62.32-62.32S234.42,137.68,200,137.68L200,137.68z"
        />
        <path
          v-if="onOffArray[5]"
          id="Runninglight28"
          :style="{ fill: showingColors[5] }"
          d="M200,140.06c16.01,0,31.06,6.24,42.39,17.56c11.32,11.32,17.56,26.37,17.56,42.39
		s-6.24,31.06-17.56,42.39c-11.32,11.32-26.37,17.56-42.39,17.56s-31.06-6.24-42.39-17.56c-11.32-11.32-17.56-26.37-17.56-42.39
		s6.24-31.06,17.56-42.39C168.94,146.29,183.99,140.06,200,140.06 M200,139.67c-33.32,0-60.33,27.01-60.33,60.33
		s27.01,60.33,60.33,60.33s60.33-27.01,60.33-60.33S233.32,139.67,200,139.67L200,139.67z"
        />
        <path
          v-if="onOffArray[6]"
          id="Runninglight29"
          :style="{ fill: showingColors[6] }"
          d="M200,142.03c15.48,0,30.04,6.03,40.99,16.98s16.98,25.5,16.98,40.99
		s-6.03,30.04-16.98,40.99s-25.5,16.98-40.99,16.98s-30.04-6.03-40.99-16.98s-16.98-25.5-16.98-40.99s6.03-30.04,16.98-40.99
		S184.52,142.03,200,142.03 M200,141.65c-32.23,0-58.35,26.13-58.35,58.35s26.13,58.35,58.35,58.35s58.35-26.13,58.35-58.35
		S232.23,141.65,200,141.65L200,141.65z"
        />
        <path
          v-if="onOffArray[6]"
          id="Runninglight30"
          :style="{ fill: showingColors[6] }"
          d="M200,144c14.96,0,29.02,5.83,39.6,16.4c10.58,10.58,16.4,24.64,16.4,39.6
		s-5.83,29.02-16.4,39.6C229.02,250.18,214.96,256,200,256s-29.02-5.83-39.6-16.4C149.82,229.02,144,214.96,144,200
		s5.83-29.02,16.4-39.6C170.98,149.82,185.04,144,200,144 M200,143.63c-31.13,0-56.37,25.24-56.37,56.37s25.24,56.37,56.37,56.37
		s56.37-25.24,56.37-56.37S231.13,143.63,200,143.63L200,143.63z"
        />
        <path
          v-if="onOffArray[7]"
          id="Runninglight31"
          :style="{ fill: showingColors[7] }"
          d="M200,145.97c14.43,0,28,5.62,38.2,15.82c10.2,10.2,15.82,23.77,15.82,38.2
		s-5.62,28-15.82,38.2s-23.77,15.82-38.2,15.82s-28-5.62-38.2-15.82c-10.2-10.2-15.82-23.77-15.82-38.2s5.62-28,15.82-38.2
		C172,151.59,185.57,145.97,200,145.97 M200,145.61c-30.04,0-54.39,24.35-54.39,54.39s24.35,54.39,54.39,54.39
		s54.39-24.35,54.39-54.39S230.04,145.61,200,145.61L200,145.61z"
        />
        <path
          v-if="onOffArray[7]"
          id="Runninglight32"
          :style="{ fill: showingColors[7] }"
          d="M200,147.93c13.91,0,26.98,5.42,36.82,15.25c9.83,9.83,15.25,22.91,15.25,36.82
		s-5.42,26.98-15.25,36.82c-9.83,9.83-22.91,15.25-36.82,15.25s-26.98-5.42-36.82-15.25c-9.83-9.83-15.25-22.91-15.25-36.82
		s5.42-26.98,15.25-36.82C173.02,153.35,186.09,147.93,200,147.93 M200,147.59c-28.94,0-52.41,23.46-52.41,52.41
		s23.46,52.41,52.41,52.41s52.41-23.46,52.41-52.41S228.94,147.59,200,147.59L200,147.59z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import ablauf_twister from "../assets/ablauf_twister.json";
import ablauf_rainbowlight from "../assets/ablauf_rainbowlight.json";
import ablauf_runninglight from "../assets/ablauf_runninglight.json";
import ablauf_lichtwalze from "../assets/ablauf_lichtwalze.json";
import PlayIcon from "vue-material-design-icons/Play";
import StopIcon from "vue-material-design-icons/Stop";

export default {
  name: "Visualization",
  components: {
    PlayIcon,
    StopIcon
  },
  props: {
    color: { type: String, default: "" },
    speed: { type: String, default: "normal" },
    program: { type: String, default: "alle blinken" },
    index: { type: Number, default: 0 },
    slidePart: { type: Number, default: 1 }
  },
  data() {
    return {
      showingColors: [],
      onOffArray: [0, 0, 0, 0, 0, 0, 0, 0],
      duration: 40,
      slidePartIndex: 1,
      effect: 1,
      animationFrame: 0,
      programArray: ablauf_runninglight,
      mountedView: false,
      animationOn: false,
      fps: 20,
      animateNow: 0,
      animateThen: 0,
      animationInterval: 0,
      animationDelta: 0
    };
  },
  watch: {
    color: {
      handler: async function(newVal) {
        switch (newVal) {
          case "rot":
            this.assignColors("#e63232");
            break;
          case "grün":
            this.assignColors("#8cc83c");
            break;
          case "blau":
            this.assignColors("#14b4f0");
            break;
          case "weiß":
            this.assignColors("#e6e6e6");
            break;
          case "gelb":
            this.assignColors("#f0dc1e");
            break;
          case "magenta":
            this.assignColors("#FF00FF");
            break;
          case "cyan":
            this.assignColors("#00FFFF");
            break;
          case "Regenbogen": {
            this.showingColors = [];
            const colorArray = [
              "red",
              "orange",
              "#f0dc1e",
              "#8cc83c",
              "#00dcdc",
              "#14b4f0",
              "#0c3df0",
              "violet"
            ];
            for (let i = 0; i < colorArray.length; i++)
              this.showingColors.push(colorArray[i]);
            break;
          }
          case "cyan-magenta-gelb": {
            this.showingColors = [];
            const colorArray = [
              "#00dcdc",
              "#dc00dc",
              "#f0dc1e",
              "white",
              "#00dcdc",
              "#dc00dc",
              "#f0dc1e",
              "white"
            ];
            for (let i = 0; i < colorArray.length; i++)
              this.showingColors.push(colorArray[i]);
            break;
          }
          case "blau-weiß": {
            this.showingColors = [];
            const colorArray = [
              "#14b4f0",
              "white",
              "#14b4f0",
              "white",
              "#14b4f0",
              "white",
              "#14b4f0",
              "white"
            ];
            for (let i = 0; i < colorArray.length; i++)
              this.showingColors.push(colorArray[i]);
            break;
          }
          case "gelb-rot": {
            this.showingColors = [];
            const colorArray = [
              "#f0dc1e",
              "#e63232",
              "#f0dc1e",
              "#e63232",
              "#f0dc1e",
              "#e63232",
              "#f0dc1e",
              "#e63232"
            ];
            for (let i = 0; i < colorArray.length; i++)
              this.showingColors.push(colorArray[i]);
            break;
          }
          case "cyan-magenta": {
            this.showingColors = [];
            const colorArray = [
              "#00dcdc",
              "#dc00dc",
              "#00dcdc",
              "#dc00dc",
              "#00dcdc",
              "#dc00dc",
              "#00dcdc",
              "#dc00dc"
            ];
            for (let i = 0; i < colorArray.length; i++)
              this.showingColors.push(colorArray[i]);
            break;
          }
          default:
            this.assignColors("orange");
        }
        // start animation
        if (this.mountedView) {
          await this.stopAnimation();
          this.startAnimation();
        }
      },
      immediate: true
    },
    speed: {
      handler: "mapSpeed",
      immediate: true
    },
    program: {
      handler: "mapProgram",
      immediate: true
    },
    slidePart: {
      handler: "mapSlidePart",
      immediate: true
    }
  },
  mounted() {
    this.mountedView = true;
    this.animationInterval = 1000 / 15;
  },
  methods: {
    async mapSpeed(speedVal) {
      switch (speedVal) {
        case "sehr langsam":
          this.animationInterval = 1000 / 4;
          break;
        case "langsam":
          this.animationInterval = 1000 / 7;
          break;
        case "schnell":
          this.animationInterval = 1000 / 28;
          break;
        case "sehr schnell":
          this.animationInterval = 1000 / 40;
          break;
        default:
          this.animationInterval = 1000 / 15;
      }
      // start animation
      if (this.mountedView && !this.animationOn) {
        this.startAnimation();
      }
    },
    mapSlidePart(programVal) {
      // console.log("slide part old: ", this.programArray);
      // console.log("slide part new: ", programVal);
      console.log(programVal, "in mapslider");
      switch (programVal) {
        case 0:
          this.slidePartIndex = programVal;
          this.programArray = ablauf_runninglight;
          break;
        case 1:
          this.slidePartIndex = programVal;
          this.programArray = ablauf_runninglight;
          break;
        case 2:
          this.slidePartIndex = programVal;
          this.programArray = ablauf_twister;
          break;
        default:
          this.slidePartIndex = "1";
          this.programArray = ablauf_runninglight;
      }
    },
    async mapProgram(programVal) {
      switch (programVal) {
        case "alle blinken":
          this.effect = 1;
          break;
        case "dunkle Schlange":
          this.effect = 2;
          break;
        case "eine Schlange rotiert":
          this.effect = 12;
          break;
        case "3 Bänder":
          this.effect = 13;
          break;
        case "hintereinander Aufleuchten":
          this.effect = 15;
          break;
        default:
          this.effect = 1;
      }
      // start animation
      if (this.mountedView) {
        this.stopAnimation();
        this.startAnimation();
      }
    },
    animate(now) {
      if (this.animationOn) {
        requestAnimationFrame(this.animate); // request animation frame
        this.animationDelta = now - this.animateThen;

        if (this.animationDelta > this.animationInterval) {
          // animation stuff
          this.effect = Math.min(this.programArray.length, this.effect);
          this.animationFrame =
            (this.animationFrame + 1) %
            this.programArray[this.effect - 1].length;
          this.onOffArray = this.programArray[this.effect - 1][
            this.animationFrame
          ];
          this.animateThen =
            now - (this.animationDelta % this.animationInterval);
        }
      }
    },
    startAnimation() {
      this.animationOn = true;
      this.animate(0);
    },
    stopAnimation() {
      this.animationOn = false;
    },
    assignColors(colorCode) {
      let array = [];
      for (let i = 0; i < 8; i++) {
        array[i] = colorCode;
      }
      this.showingColors = array;
    }
  }
};
</script>

<style scoped>
.box {
  width: 400px;
  height: 400px;
}

.inactive {
  display: none;
}

.controls {
  position: absolute;
  font-size: 2rem;
}

.controls .material-design-icon__svg {
  height: 40px;
  width: 40px;
}

.p-icon,
.s-icon {
  cursor: pointer;
  padding-right: 10px;
}

.p-icon:hover {
  color: rgba(0, 167, 255, 1);
}

.s-icon:hover {
  color: black;
}

.st0 {
  fill: #6e6e6e;
}
.st1 {
  fill: #1a1a1a;
}
.st2 {
  opacity: 0.08;
  fill: #ffffff;
}
.st3 {
  opacity: 0.2;
}
.st4 {
  opacity: 0.1;
  fill: #ffffff;
}
.st5 {
  opacity: 0.5;
}
.st6 {
  opacity: 0.3;
}
.st7 {
  opacity: 0.07;
  fill: #ffffff;
}
.st8 {
  display: none;
  fill: #ffffff;
}
.st9 {
  display: none;
}
.st10 {
  display: inline;
  fill: #f0dc1e;
}
.st11 {
  display: inline;
  opacity: 0.7;
  fill: #f0dc1e;
}
.st12 {
  display: inline;
}
.st13 {
  fill: #f0dc1e;
}
</style>
